"use strict";

const accueil = document.body.classList.contains('body--accueil');
const test = document.querySelector('.test') !== null;
const avant = document.querySelector('.avant') !== null;
const explications = document.querySelector('.explications') !== null;
const goButton = document.querySelector('.accueil__button');
const accueilSection = document.querySelector('.accueil');
const preferencesSection = document.querySelector('.preferences');
const preferencesButtons = document.querySelectorAll('.preferences__button');
const instructionsSection = document.querySelector('.instructions');
const instructionsButton = document.querySelector('.instructions__button');
const apprentissageSection = document.querySelector('.apprentissage');
const apprentissageButton = document.querySelector('.apprentissage__button');
const avantSection = document.querySelector('.avant');
const testSection = document.querySelector('.test');
const timerApprentissage = document.querySelector(".apprentissage__timer span");
const audioElement = document.getElementById("testAudio");
let isPaused = false;

/* Minuteur Test */
let totalTime = 30;
let timerInterval;
const timerElement = document.querySelector('.test__minuteur');

if (accueil) {
    if(avant){
        document.querySelector('.avant__bouton').addEventListener('click', function() {
            document.querySelector('.avant').classList.add('avant--hidden');
            initTest();
            if (audioElement && audioElement.paused) {
              audioElement.play();
          }
        });
    }
    
    /* c'est parti */
    goButton.addEventListener('click', () => {
        accueilSection.classList.add('accueil--hidden');
        preferencesSection.classList.remove('preferences--hidden');
    });

    /* preferences */
    preferencesButtons.forEach(button => {
        button.addEventListener('click', () => {
            preferencesSection.classList.add('preferences--hidden');
            instructionsSection.classList.remove('instructions--hidden');
        });
    });

    /* Instructions */
    instructionsButton.addEventListener('click', () => {
        instructionsSection.classList.add('instructions--hidden');
        apprentissageSection.classList.remove('apprentissage--hidden');
        startCountdown(120);
    });

    /* Apprentissage */
    apprentissageButton.addEventListener('click', () => {
        apprentissageSection.classList.add('apprentissage--hidden');
        avantSection.classList.remove('avant--hidden');
        testSection.classList.remove('test--hidden');
    });

    let countdownInterval;

    function startCountdown(duration) {
        let timeRemaining = duration;

        countdownInterval = setInterval(() => {
            const minutes = Math.floor(timeRemaining / 60);
            const seconds = timeRemaining % 60;

            timerApprentissage.textContent = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

            if (timeRemaining <= 0) {
                clearInterval(countdownInterval);
                timerApprentissage.textContent = "0:00";
                apprentissageSection.classList.add('apprentissage--hidden');
                avantSection.classList.remove('avant--hidden');
                testSection.classList.remove('test--hidden');
            }

            timeRemaining--;
        }, 1000);
    }
}

function initTest() {
    /* Explications */
    if(explications){
        document.querySelector('.explications__bouton').addEventListener('click', function() {
            document.querySelector('.explications').classList.add('explications--hidden');
            isPaused = false;
            startTimer();
        });
    }

    /* Timer test */
    function startTimer() {
        clearInterval(timerInterval);
    
        totalTime = 30;
        timerInterval = setInterval(() => {
            if (!isPaused) {
                const seconds = totalTime % 60;
    
                timerElement.textContent = `00:${seconds < 10 ? '0' : ''}${seconds}`;
    
                totalTime--;
    
                if (totalTime < 0) {
                    clearInterval(timerInterval);
                    timerElement.textContent = "00:30";
                    validerEtSuivante();
                }
            }
        }, 1000);
    }

    /* Couleur Réponses */
    const buttons = document.querySelectorAll('.test__reponse');
    const validationButton = document.querySelector('.test__validation');
    const testContainer = document.querySelector('.test');
    const backgoundImg = document.querySelector('.test__img');
    const resultatsContainer = document.querySelector('.resultats');

    buttons.forEach(button => {
        button.addEventListener('click', function() {
            buttons.forEach(btn => btn.classList.remove('test__reponse--active'));

            this.classList.add('test__reponse--active');
            validationButton.classList.remove('test__validation--hidden');
        });
    });

    /* Variables pour le score */
    let currentQuestionIndex = 0;
    let questionData = [];
    let scoreFirstHalf = 0;
    let scoreSecondHalf = 0;
    const totalQuestionsFirstHalf = 8;
    const totalQuestionsSecondHalf = 8;

    const reponses = document.querySelectorAll(".test__reponse");

    async function chargerQuestions() {
        try {
            const response = await fetch('assets/donnees/questions.json');
            if (!response.ok) {
                throw new Error('Erreur HTTP : ' + response.status);
            }
            questionData = await response.json();
            afficherQuestion();
        } catch (error) {
            console.error('Erreur lors du chargement du JSON :', error);
        }
    }

    function afficherQuestion() {
        if (currentQuestionIndex < questionData.length) {
            const question = questionData[currentQuestionIndex];

            // Affichage de l'image d'arrière-plan en fonction du numéro de question
            const numeroQuestion = question["numéro de question"].match(/\d+/)[0];
            backgoundImg.style.backgroundImage = `url('assets/images/${numeroQuestion}.webp')`;

            document.querySelector(".test__numero").innerText = question["numéro de question"];
            document.querySelector(".test__intitule").innerText = question["intitulé"];

            reponses[0].innerText = "A. " + question["réponse A"];
            reponses[1].innerText = "B. " + question["réponse B"];
            reponses[2].innerText = "C. " + question["réponse C"];
            reponses[3].innerText = "D. " + question["réponse D"];

            startTimer();
        } else {
            console.log('Toutes les questions ont été affichées.');
        }
    }

    function calculerScore() {
        const scoreFirstHalfPercentage = Math.round((scoreFirstHalf / totalQuestionsFirstHalf) * 100);
        const scoreSecondHalfPercentage = Math.round((scoreSecondHalf / totalQuestionsSecondHalf) * 100);

        const resultFirstHalf = document.querySelector('.resultats__list .resultats__el:nth-child(1) .resultats__score');
        const resultSecondHalf = document.querySelector('.resultats__list .resultats__el:nth-child(2) .resultats__score');

        resultFirstHalf.textContent = `${scoreFirstHalfPercentage}%`;
        resultSecondHalf.textContent = `${scoreSecondHalfPercentage}%`;
    }

    function validerEtSuivante() {
        const question = questionData[currentQuestionIndex];
        const selectedAnswer = document.querySelector('.test__reponse--active');
    
        if (selectedAnswer) {
            const userAnswer = selectedAnswer.innerText[0].toLowerCase();
            if (userAnswer === question["bonne réponse"]) {
                if (currentQuestionIndex < totalQuestionsFirstHalf) {
                    scoreFirstHalf++;
                } else if (currentQuestionIndex >= questionData.length - totalQuestionsSecondHalf) {
                    scoreSecondHalf++;
                }
            }
        }
    
        reponses.forEach(button => {
            button.classList.remove('test__reponse--active');
        });
        validationButton.classList.add('test__validation--hidden');
        currentQuestionIndex++;
    
        // Vérification pour afficher les explications après la 8ème question
        if (currentQuestionIndex === 8) {
            isPaused = true;
            document.querySelector('.explications').classList.remove('explications--hidden');
        }
    
        if (currentQuestionIndex === questionData.length) {
            calculerScore();
            testContainer.classList.add('test--hidden');
            resultatsContainer.classList.remove('resultats--hidden');
        } else {
            afficherQuestion();
        }
    } 

    validationButton.addEventListener("click", validerEtSuivante);

    chargerQuestions();
}



/* Parametres */
const settingsButton = document.querySelector('.nav__el button');
const settingsSection = document.querySelector('.parametres');
const validateButton = document.querySelector('.parametres__validation');

settingsButton.addEventListener('click', () => {
  settingsSection.classList.toggle('parametres--hidden');
});

validateButton.addEventListener('click', () => {
  settingsSection.classList.add('parametres--hidden');
});

/* une seul checkbox */
const checkboxes = document.querySelectorAll('.parametres__list input[type="checkbox"]');

checkboxes.forEach(checkbox => {
  checkbox.addEventListener('change', function() {
    if (this.checked) {
      // Si l'une est cochée, décocher les autres
      checkboxes.forEach(otherCheckbox => {
        if (otherCheckbox !== this) {
          otherCheckbox.checked = false;
        }
      });
    }
  });
});







/* Récupération de l'état sauvegardé dans le localStorage (valeur "true" ou "false") */
let textSizeMode = localStorage.getItem('textSizeMode') === 'true';
updateTextSizeClasses(textSizeMode);

// Sélection des éléments
const textSizeCheckbox = document.querySelector('#toggle-agrandissement');
const textSizeButton = document.querySelector('#aggrandissement');

// Mise à jour initiale des états
if (textSizeCheckbox) {
  textSizeCheckbox.checked = textSizeMode;
}
if (textSizeButton) {
  textSizeButton.classList.toggle('preferences__button--active', textSizeMode);
}

// Gestion du checkbox des préférences
if (textSizeCheckbox) {
  textSizeCheckbox.addEventListener('change', function() {
    textSizeMode = textSizeCheckbox.checked;
    updateTextSizeClasses(textSizeMode);
    localStorage.setItem('textSizeMode', textSizeMode);

    // Synchroniser le bouton de navigation
    if (textSizeButton) {
      textSizeButton.classList.toggle('preferences__button--active', textSizeMode);
    }
  });
}

// Gestion du bouton de navigation
if (textSizeButton) {
  textSizeButton.addEventListener('click', function() {
    textSizeMode = !textSizeMode;
    updateTextSizeClasses(textSizeMode);
    localStorage.setItem('textSizeMode', textSizeMode);

    // Synchroniser la checkbox des préférences
    if (textSizeCheckbox) {
      textSizeCheckbox.checked = textSizeMode;
    }
  });
}

// Gestion du logo : réinitialise le mode Texte Agrandi
const logo = document.querySelector('.nav__logo');
if (logo) {
  logo.addEventListener('click', function() {
    localStorage.setItem('textSizeMode', 'false');
    updateTextSizeClasses(false);

    if (textSizeCheckbox) {
      textSizeCheckbox.checked = false;
    }

    if (textSizeButton) {
      textSizeButton.classList.remove('preferences__button--active');
    }
  });
}

/* Fonction pour mettre à jour les classes de texte agrandi */
function updateTextSizeClasses(active) {
  const textElements = document.querySelectorAll('p, span, h1, h2, h3, h4, li');
  const instructionContents = document.querySelectorAll('.instructions__contenu');
  const stepImages = document.querySelectorAll('.etape__image');

  textElements.forEach(element => {
    element.classList.remove('text-size-active', 'h1', 'h2', 'h3', 'h4', 'p', 'span', 'li');

    if (active) {
      element.classList.add('text-size-active', element.tagName.toLowerCase());
    }
  });

  // Ajouter ou retirer la classe .instructions__contenu--agrandis
  instructionContents.forEach(content => {
    if (active) {
      content.classList.add('instructions__contenu--agrandis');
    } else {
      content.classList.remove('instructions__contenu--agrandis');
    }
  });

  // Ajouter ou retirer la classe .etape__image--agrandis
  stepImages.forEach(image => {
    if (active) {
      image.classList.add('etape__image--agrandis');
    } else {
      image.classList.remove('etape__image--agrandis');
    }
  });
}



// Gestion du Mode Dyslexique
function updateDyslexicClasses(active) {
  document.body.classList.toggle('dyslexic-font', active);

  document.querySelectorAll('.apprentissage__timer').forEach(timer => {
    timer.classList.toggle('apprentissage__timer--dyslexic', active);
  });

  document.querySelectorAll('.nav__el').forEach(el => {
    el.classList.toggle('nav--dyslexic', active);
  });

  document.querySelectorAll('.instructions__contenu').forEach(el => {
    el.classList.toggle('instructions__contenu--dyslexic', active);
  });

  document.querySelectorAll('.etape__image').forEach(el => {
    el.classList.toggle('etape__image--dyslexic', active);
  });

  document.querySelectorAll('.comprendre__contenu').forEach(el => {
    el.classList.toggle('comprendre__contenu--dyslexic', active);
  });

  document.querySelectorAll('.pmr__el').forEach(el => {
    el.classList.toggle('pmr--dyslexic', active);
  });
}

// Initialisation du mode dyslexique
let dyslexicMode = localStorage.getItem('dyslexicMode') === 'true';
updateDyslexicClasses(dyslexicMode);

const mainCheckbox = document.querySelector('#toggle-dyslexique');
if (mainCheckbox) {
  mainCheckbox.checked = dyslexicMode;
  mainCheckbox.addEventListener('change', function() {
    const newState = this.checked;
    updateDyslexicClasses(newState);
    localStorage.setItem('dyslexicMode', newState);
  });
}

const toggles = document.querySelectorAll('.dyslexie__toggle');
toggles.forEach(toggle => {
  if (toggle.type !== 'checkbox') {
    toggle.addEventListener('click', function() {
      dyslexicMode = !dyslexicMode;
      updateDyslexicClasses(dyslexicMode);
      localStorage.setItem('dyslexicMode', dyslexicMode);
      if (mainCheckbox) mainCheckbox.checked = dyslexicMode;
    });
  }
});

if (logo) {
  logo.addEventListener('click', function() {
    localStorage.setItem('dyslexicMode', 'false');
    updateDyslexicClasses(false);
    if (mainCheckbox) mainCheckbox.checked = false;
  });
}


if (accueil) {
// Gestion des Checkboxes des Instructions
const instructionsCheckboxes = document.querySelectorAll('.instructions__checkbox');

function checkCompletion() {
  const allChecked = [...instructionsCheckboxes].every(cb => cb.checked);
  instructionsButton.disabled = !allChecked;
  instructionsButton.classList.toggle('instructions__button--disabled', !allChecked);
}

instructionsCheckboxes.forEach(checkbox => {
  checkbox.addEventListener('change', checkCompletion);
});

checkCompletion();

  
}

  // Sélectionner l'élément des résultats
const resultatsSection = document.querySelector('.resultats');

if (resultatsSection) {
    // Créer un observer pour surveiller les changements de classes
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const isHidden = resultatsSection.classList.contains('resultats--hidden');
                
                // Si la classe 'resultats--hidden' est retirée, on arrête le son
                if (!isHidden && audioElement && !audioElement.paused) {
                    audioElement.pause();
                    audioElement.currentTime = 0;
                }
            }
        }
    });

    // Configurer l'observer pour surveiller les attributs
    observer.observe(resultatsSection, { attributes: true });
}


document.addEventListener("DOMContentLoaded", function () {
  const falcCheckbox = document.querySelector('#toggle-falc');
  const falcButton = document.querySelector('#falc');

  const textSizeCheckbox = document.querySelector('#toggle-agrandissement');
  const textSizeButton = document.querySelector('#aggrandissement');

  /**
   * Met à jour le mode spécifique
   * @param {string} mode - Le mode à mettre à jour ("falcMode", "textSizeMode")
   * @param {boolean} isActive - L'état actif ou non
   */
  function updateMode(mode, isActive) {

    const classMap = {
      falcMode: 'falc-active',
      textSizeMode: 'text-size-mode'
    };

    const buttonMap = {
      falcMode: falcButton,
      textSizeMode: textSizeButton
    };

    const checkboxMap = {
      falcMode: falcCheckbox,
      textSizeMode: textSizeCheckbox
    };

    // Mettre à jour le body, le localStorage, le bouton et la checkbox
    document.body.classList.toggle(classMap[mode], isActive);
    buttonMap[mode]?.classList.toggle('preferences__button--active', isActive);
    checkboxMap[mode].checked = isActive;
    localStorage.setItem(mode, isActive);
  }

  /**
   * Charger les états initiaux
   */
  function loadInitialStates() {
    const falcState = localStorage.getItem('falcMode') === 'true';
    const textSizeState = localStorage.getItem('textSizeMode') === 'true';

    updateMode('falcMode', falcState);
    updateMode('textSizeMode', textSizeState);
  }

  /**
   * Réinitialise tous les modes
   */
  function resetModes() {
    updateMode('falcMode', false);
    updateMode('textSizeMode', false);
  }

  // Charger les états initiaux
  loadInitialStates();

  // Événements pour les checkboxes
  falcCheckbox?.addEventListener('change', () => updateMode('falcMode', falcCheckbox.checked));
  textSizeCheckbox?.addEventListener('change', () => updateMode('textSizeMode', textSizeCheckbox.checked));

  // Événements pour les boutons
  falcButton?.addEventListener('click', () => updateMode('falcMode', !falcCheckbox.checked));
  textSizeButton?.addEventListener('click', () => updateMode('textSizeMode', !textSizeCheckbox.checked));

  // Réinitialisation via .nav__reset
  const resetButtons = document.querySelectorAll('.reset');
  resetButtons.forEach(button => {
    button.addEventListener('click', resetModes);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const checkboxes = document.querySelectorAll('.instructions__checkbox');
  
  // Cocher la première checkbox par défaut
  if (checkboxes[0]) {
    checkboxes[0].checked = true;
    checkboxes[0].closest('.instructions__etape').style.opacity = "1";
  }

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      const parentLi = this.closest('.instructions__etape');
      if (this.checked) {
        parentLi.style.opacity = "1";
      } else {
        parentLi.style.opacity = "0.5";
      }
    });
  });
});




document.addEventListener("DOMContentLoaded", function () {
  const checkboxes = document.querySelectorAll('.parametres__list input[type="checkbox"]');
  const dyslexicCheckbox = document.getElementById('toggle-dyslexique');
  const falcCheckbox = document.getElementById('toggle-falc');
  const textSizeCheckbox = document.getElementById('toggle-agrandissement');

  const dyslexieButton = document.getElementById('dyslexie-btn');
  const falcButton = document.getElementById('falc');
  const agrandissementButton = document.getElementById('aggrandissement');

  /**
   * Réinitialise tous les modes
   */
  function resetModes() {
    document.body.classList.remove('dyslexic-font', 'falc-active', 'text-size-active');
    document.body.classList.add('text-size-disabled');

    localStorage.setItem('dyslexicMode', false);
    localStorage.setItem('falcMode', false);
    localStorage.setItem('textSizeMode', false);

    // Réinitialiser toutes les checkboxes
    checkboxes.forEach(cb => cb.checked = false);
  }

  /**
   * Applique le mode correspondant
   * @param {string} mode - Le mode à appliquer ("dyslexic", "falc", "textSize")
   */
  function applyMode(mode) {
    resetModes(); // Toujours réinitialiser avant d'appliquer

    switch (mode) {
      case 'dyslexic':
        document.body.classList.add('dyslexic-font');
        localStorage.setItem('dyslexicMode', true);
        dyslexicCheckbox.checked = true;
        break;

      case 'falc':
        document.body.classList.add('falc-active');
        localStorage.setItem('falcMode', true);
        falcCheckbox.checked = true;
        break;

      case 'textSize':
        document.body.classList.add('text-size-active');
        document.body.classList.remove('text-size-disabled');
        localStorage.setItem('textSizeMode', true);
        textSizeCheckbox.checked = true;
        break;
    }
  }

  /**
   * Gère le changement d'état des checkboxes
   */
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {

      // Si toggle-agrandissement est décoché, on réinitialise les modes
      if (this.id === 'toggle-agrandissement' && !this.checked) {
        resetModes();
        return;
      }

      if (this.checked) {
        resetModes(); // Toujours réinitialiser avant d'appliquer

        switch (this.id) {
          case 'toggle-dyslexique':
            applyMode('dyslexic');
            break;
          case 'toggle-falc':
            applyMode('falc');
            break;
          case 'toggle-agrandissement':
            applyMode('textSize');
            break;
        }
      }
    });
  });

  /**
   * Gestion des boutons de préférence
   */
  if (dyslexieButton) {
    dyslexieButton.addEventListener('click', function () {
      applyMode('dyslexic');
    });
  }

  if (falcButton) {
    falcButton.addEventListener('click', function () {
      applyMode('falc');
    });
  }

  if (agrandissementButton) {
    agrandissementButton.addEventListener('click', function () {
      applyMode('textSize');
    });
  }

  /**
   * Charger les états initiaux
   */
  function loadInitialStates() {
    const dyslexicMode = localStorage.getItem('dyslexicMode') === 'true';
    const falcMode = localStorage.getItem('falcMode') === 'true';
    const textSizeMode = localStorage.getItem('textSizeMode') === 'true';

    if (dyslexicMode) {
      applyMode('dyslexic');
    } 
    else if (falcMode) {
      applyMode('falc');
    } 
    else if (textSizeMode) {
      applyMode('textSize');
    } else {
      // Si aucun mode actif, on active la classe `text-size-disabled`
      document.body.classList.add('text-size-disabled');
    }
  }

  loadInitialStates();
});


